import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";
import agent from "../api/agent";
import { getToastTranslation } from "../helpers/translationHelper";
import { INote, INoteModalParams } from "../models/note";
import { RootStore } from "./rootStore";

export default class NoteStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  // METODI WRAPPER
  loadNote = async (params: INoteModalParams) => {
    let note: INote = { text: "" };
    try {
      if (params.contentId) {
        note = await this.loadContentNote(params.contentId);
      } else if (params.fileId) {
        note = await this.loadFileNote(params.fileId);
      } else throw new Error("loadNote - Invalid parameters");
      return note;
    } catch (error) {
      console.log(error);
      this.rootStore.playerStore.closeShowNoteModal();
      return note;
    }
  };

  submitNote = async (params: INoteModalParams, note: INote) => {
    try {
      if (params.contentId) {
        await this.submitContentNote(params.contentId, note);
      } else if (params.fileId) {
        await this.submitFileNote(params.fileId, note);
      } else throw new Error("loadNote - Invalid parameters");
      this.rootStore.playerStore.closeShowNoteModal();
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  deleteNote = async (params: INoteModalParams) => {
    try {
      if (params.contentId) {
        await this.deleteContentNote(params.contentId);
      } else if (params.fileId) {
        await this.deleteFileNote(params.fileId);
      } else throw new Error("loadNote - Invalid parameters");
      this.rootStore.playerStore.closeShowNoteModal();
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  // METODI NOTE DEL CONTENT
  loadContentNote = async (contentId: number) => {
    try {
      const dto = await agent.Note.getContentNote(contentId);
      runInAction(() => {});
      return dto;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  submitContentNote = async (contentId: number, note: INote) => {
    try {
      await agent.Note.postContentNote(contentId, note);
      runInAction(() => {
        toast.success(getToastTranslation("notes_save_ok"))
        this.rootStore.commonStore.setContentNote(true);
      });
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  deleteContentNote = async (contentId: number) => {
    try {
      await agent.Note.deleteContentNote(contentId);
      runInAction(() => {
        toast.success(getToastTranslation("notes_save_ok"));
        this.rootStore.commonStore.setContentNote(false);
      });
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  // METODI NOTE DEL FILE
  loadFileNote = async (fileId: number) => {
    try {
      const dto = await agent.Note.getFileNote(fileId);
      runInAction(() => {});
      return dto;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  submitFileNote = async (fileId: number, note: INote) => {
    try {
      await agent.Note.postFileNote(fileId, note);
      runInAction(() => {
        toast.success(getToastTranslation("notes_save_ok"));
        this.rootStore.commonStore.setFileNote(fileId, true);
      });
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  deleteFileNote = async (fileId: number) => {
    try {
      await agent.Note.deleteFileNote(fileId);
      runInAction(() => {
        toast.success(getToastTranslation("notes_save_ok"));
        this.rootStore.commonStore.setFileNote(fileId, false);
      });
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
}
